{
  "ContextualRecords": {
    "loadingRecord": "Loading record…",
    "registration": "Registration",
    "backToWorkspace": "Back to Workspace",
    "backToRecord": "Back to Record",
    "finishEditing": "Save or cancel your changes before opening another record.",
    "openFullRecord": "Open Full Record",
    "practice": "Practice",
    "discardUnsavedRecordChanges": "Discard unsaved record changes?"
  },
  "InvitationQrDialog": {
    "invitationQrCode": "Invitation QR Code",
    "downloadPng": "Download PNG",
    "copyPngImage": "Copy PNG Image",
    "retryQrCode": "Retry QR Code",
    "couldNotCreateTheQrCodeTry": "Could not create the QR code. Try again.",
    "creatingQrCode": "Creating QR code…",
    "imageCopyingIsUnavailableInThisBrowser": "Image copying is unavailable in this browser. Download the PNG to share it.",
    "pngImageCopied": "PNG image copied.",
    "theImageCouldNotBeCopiedAllow": "The image could not be copied. Allow clipboard access and try again, or download the PNG.",
    "description": "{{variant}} doctor / practice invitation",
    "imageDescription": "{{variant}} invitation QR code"
  },
  "PracticePreview": {
    "yourCurrentAccountDoesNotHaveAccess": "Your current account does not have access to this Practice.",
    "practiceUnavailable": "Practice unavailable",
    "thisPracticeIsUnavailableOrOutsideYour": "This Practice is unavailable or outside your permitted scope."
  },
  "BarChart": {
    "viewDailyCounts": "View Daily Counts",
    "activityByDay": "Activity by day",
    "date": "Date",
    "count": "Count",
    "summary": "{{label}}. Highest daily count: {{count}}. Exact counts are available below."
  },
  "CopyButton": {
    "copied": "Copied",
    "retryCopy": "Retry copy",
    "retryCopyAction": "Retry Copy",
    "copyFailedTryAgainOrSelectAnd": "Copy failed. Try again or select and copy the text.",
    "copying": "Copying",
    "copy": "Copy",
    "copiedLabel": "Copied: {{label}}",
    "retryLabel": "Retry: {{label}}"
  },
  "Skeleton": {
    "loading": "Loading…",
    "stillLoading": "Still loading…"
  },
  "DataState": {
    "notAllowed": "Not allowed",
    "yourRoleDoesNotIncludeAccessTo": "Your role does not include access to this view.",
    "couldNotLoadThisView": "Could not load this view",
    "retry": "Retry",
    "tryAgainIfTheProblemContinuesContact": "Try again. If the problem continues, contact your administrator.",
    "thisViewIsUnavailable": "This view is unavailable",
    "weCouldnTReachTheseRecordsTry": "We couldn’t reach these records. Try again, or contact your administrator if the problem continues.",
    "notFound": "Not found",
    "thisRecordDoesNotExistOrIs": "This record does not exist or is no longer available."
  },
  "DataTable": {
    "sortAppliesToThisPage": "Sort applies to this page",
    "sortAppliesToLoadedRecords": "Sort applies to loaded records",
    "sortBy": "Sort By ",
    "sortColumn": "Sort by {{column}}",
    "defaultOrder": "Default Order",
    "ascending": "{{column}} · Ascending",
    "descending": "{{column}} · Descending",
    "tableDisplay": "Table display",
    "rowDensity": "Row density",
    "compact": "Compact",
    "comfortable": "Comfortable",
    "resetColumns": "Reset Columns",
    "thisViewIsUnavailable": "This view is unavailable",
    "weCouldnTReachTheseRecordsTry": "We couldn’t reach these records. Try again, or contact your administrator if the problem continues.",
    "retry": "Retry",
    "couldNotLoadThisList": "Could not load this list",
    "tryAgainIfTheProblemContinuesContact": "Try again. If the problem continues, contact your administrator.",
    "compactRows": "Compact rows",
    "comfortableRows": "Comfortable rows",
    "resizeColumn": "Resize {{column}} Column"
  },
  "Dialog": {
    "returnToAdministrator": "Return to Administrator",
    "dialog": "Dialog",
    "close": "Close",
    "panel": "Panel",
    "cancel": "Cancel",
    "reason": "Reason",
    "optional": " (Optional)",
    "confirm": "Confirm",
    "somethingWentWrong": "Something went wrong."
  },
  "Form": {
    "optional": " (Optional)",
    "fieldHelp": "Field help",
    "helpFor": "Help for {{label}}"
  },
  "FullPage": {
    "loading": "Loading",
    "retry": "Retry",
    "accessDenied": "Access Denied",
    "signOut": "Sign Out",
    "loading2": "Loading…"
  },
  "HelpPopover": {
    "closeHelp": "Close Help",
    "moreInformation": "More information"
  },
  "PageHeader": {
    "breadcrumb": "Breadcrumb"
  },
  "SearchSelect": {
    "searchChoices": "Search choices",
    "search": "Search…",
    "availableChoices": "Available choices",
    "noMatchingChoicesTryADifferentSearch": "No matching choices. Try a different search.",
    "choose": "Choose…"
  },
  "Toast": {
    "dismiss": "Dismiss"
  },
  "RecordNavigationGuard": {
    "discardUnsavedRecordChanges": "Discard unsaved record changes?"
  },
  "Tabs": {
    "sections": "Sections"
  },
  "Timeline": {
    "nothingYet": "Nothing yet"
  },
  "api": {
    "thisPreviewIsReadOnlyReturnTo": "This preview is read-only. Return to administrator to make changes."
  },
  "format": {
    "finalized": "Finalized",
    "completed": "Completed",
    "signed": "Signed",
    "consented": "Consented",
    "previewGenerated": "Preview generated",
    "dataCompleted": "Data completed",
    "opened": "Opened",
    "inProgress": "In progress",
    "created": "Created",
    "pageVisit": "Page visit",
    "delivered": "Delivered",
    "accepted": "Accepted",
    "sending": "Sending",
    "pending": "Pending",
    "retryPending": "Retry pending",
    "hardBounced": "Hard bounced",
    "complained": "Complained",
    "failed": "Failed",
    "email": "Email",
    "print": "Print",
    "portal": "Portal",
    "active": "Active",
    "expired": "Expired",
    "revoked": "Revoked",
    "privateSigningLink": "Private signing link",
    "resume": "Resume",
    "bundle": "Bundle",
    "disabled": "Disabled",
    "invited": "Invited",
    "startForm": "Start: {{form}}"
  },
  "FunnelChart": {
    "previousShare": "{{percent}}% of previous"
  }
}
